import { useContext } from 'react';

import { PermissionsContext } from './permissions-context';

// ----------------------------------------------------------------------

export const usePermissions = () => {
  const context = useContext(PermissionsContext);

  if (!context) throw new Error('usePermissions must be used within PermissionsProvider');

  return context;
};
